var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisableRoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#D7D7D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.982 6.48597C17.982 7.00397 17.5719 7.42397 17.0649 7.42397H7.06495C6.55795 7.42397 6.14795 7.00397 6.14795 6.48597C6.14795 5.96697 6.55795 5.54797 7.06495 5.54797H17.0649C17.5719 5.54797 17.982 5.96797 17.982 6.48597Z",
    fill: "#6B6B6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.982 20.486C17.982 21.004 17.5719 21.424 17.0649 21.424H7.06495C6.55795 21.424 6.14795 21.004 6.14795 20.486C6.14795 19.967 6.55795 19.548 7.06495 19.548H17.0649C17.5719 19.548 17.982 19.968 17.982 20.486Z",
    fill: "#6B6B6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.917 8.5H8V9.459H15.917V8.5Z",
    fill: "#6B6B6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.917 10.5H8V11.459H15.917V10.5Z",
    fill: "#6B6B6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.917 12.5H8V13.459H15.917V12.5Z",
    fill: "#6B6B6C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.917 14.5H8V15.459H15.917V14.5Z",
    fill: "#6B6B6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.917 16.5H8V17.459H15.917V16.5Z",
    fill: "#6B6B6C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.917 18.5H8V19.459H15.917V18.5Z",
    fill: "#6B6B6C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.836 20.5C20.531 20.292 20.157 18.346 20.056 17.52C19.968 16.804 19.875 12.958 17.673 11.975C17.061 11.702 16.38 11.573 15.795 11.516C15.282 11.464 15.11 11.477 15.166 11.418L14.418 10.736C14.712 10.429 15.256 10.456 15.836 10.517C16.57 10.587 17.354 10.729 18.046 11.046C20.667 12.249 20.995 16.778 21.07 17.4C21.21 18.544 21.609 19.453 22 19.514L21.836 20.5Z",
    fill: "#6B6B6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableRoll);
export default __webpack_public_path__ + "static/media/disable_roll.5d436d33eca2897438babbad507243dc.svg";
export { ForwardRef as ReactComponent };